/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfLab } from '../models/data-page-of-lab';
import { Lab } from '../models/lab';
import { labsAllTests } from '../fn/labs/labs-all-tests';
import { LabsAllTests$Params } from '../fn/labs/labs-all-tests';
import { labsDetail } from '../fn/labs/labs-detail';
import { LabsDetail$Params } from '../fn/labs/labs-detail';
import { labsGetAllLabs } from '../fn/labs/labs-get-all-labs';
import { LabsGetAllLabs$Params } from '../fn/labs/labs-get-all-labs';
import { labsGetDistinctTest } from '../fn/labs/labs-get-distinct-test';
import { LabsGetDistinctTest$Params } from '../fn/labs/labs-get-distinct-test';
import { labsGetGraphForlab } from '../fn/labs/labs-get-graph-forlab';
import { LabsGetGraphForlab$Params } from '../fn/labs/labs-get-graph-forlab';
import { labsList } from '../fn/labs/labs-list';
import { LabsList$Params } from '../fn/labs/labs-list';
import { labsViewCommnets } from '../fn/labs/labs-view-commnets';
import { LabsViewCommnets$Params } from '../fn/labs/labs-view-commnets';

@Injectable({ providedIn: 'root' })
export class LabsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `labsGetDistinctTest()` */
  static readonly LabsGetDistinctTestPath = '/labs/DDlist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labsGetDistinctTest()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsGetDistinctTest$Response(params?: LabsGetDistinctTest$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Lab>>> {
    return labsGetDistinctTest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labsGetDistinctTest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsGetDistinctTest(params?: LabsGetDistinctTest$Params, context?: HttpContext): Observable<Array<Lab>> {
    return this.labsGetDistinctTest$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Lab>>): Array<Lab> => r.body)
    );
  }

  /** Path part for operation `labsList()` */
  static readonly LabsListPath = '/lab/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsList$Response(params?: LabsList$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return labsList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsList(params?: LabsList$Params, context?: HttpContext): Observable<string> {
    return this.labsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `labsAllTests()` */
  static readonly LabsAllTestsPath = '/lab/list/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labsAllTests()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsAllTests$Response(params?: LabsAllTests$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return labsAllTests(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labsAllTests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsAllTests(params?: LabsAllTests$Params, context?: HttpContext): Observable<Array<string>> {
    return this.labsAllTests$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `labsDetail()` */
  static readonly LabsDetailPath = '/lab/detail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labsDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsDetail$Response(params?: LabsDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfLab>> {
    return labsDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labsDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsDetail(params?: LabsDetail$Params, context?: HttpContext): Observable<DataPageOfLab> {
    return this.labsDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfLab>): DataPageOfLab => r.body)
    );
  }

  /** Path part for operation `labsViewCommnets()` */
  static readonly LabsViewCommnetsPath = '/lab/comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labsViewCommnets()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsViewCommnets$Response(params?: LabsViewCommnets$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
    return labsViewCommnets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labsViewCommnets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsViewCommnets(params?: LabsViewCommnets$Params, context?: HttpContext): Observable<Lab> {
    return this.labsViewCommnets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Lab>): Lab => r.body)
    );
  }

  /** Path part for operation `labsGetGraphForlab()` */
  static readonly LabsGetGraphForlabPath = '/lab/getlabgraph';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labsGetGraphForlab()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsGetGraphForlab$Response(params?: LabsGetGraphForlab$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
    return labsGetGraphForlab(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labsGetGraphForlab$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsGetGraphForlab(params?: LabsGetGraphForlab$Params, context?: HttpContext): Observable<Lab> {
    return this.labsGetGraphForlab$Response(params, context).pipe(
      map((r: StrictHttpResponse<Lab>): Lab => r.body)
    );
  }

  /** Path part for operation `labsGetAllLabs()` */
  static readonly LabsGetAllLabsPath = '/api/Labs/getAllTests';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labsGetAllLabs()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsGetAllLabs$Response(params?: LabsGetAllLabs$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfLab>> {
    return labsGetAllLabs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labsGetAllLabs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labsGetAllLabs(params?: LabsGetAllLabs$Params, context?: HttpContext): Observable<DataPageOfLab> {
    return this.labsGetAllLabs$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfLab>): DataPageOfLab => r.body)
    );
  }

}
